import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = {
  key: 0,
  class: "spinner"
}
const _hoisted_3 = { class: "title-wrapper" }
const _hoisted_4 = { class: "default-count" }
const _hoisted_5 = { class: "filters" }
const _hoisted_6 = { class: "dropdown-button" }
const _hoisted_7 = {
  key: 0,
  class: "item-filter-double-wr"
}
const _hoisted_8 = {
  key: 1,
  class: "item-filter"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "spinner"
}
const _hoisted_11 = {
  key: 2,
  class: "empty-block--wrapper"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { class: "table-scroll scroll-wrapper" }
const _hoisted_15 = { class: "table-header" }
const _hoisted_16 = { class: "table-default" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "lot-number" }
const _hoisted_19 = { class: "leadDetails-data" }
const _hoisted_20 = { class: "bold text-highlighted" }
const _hoisted_21 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "title-row" }, [
        _createElementVNode("h1", { class: "title-main" }, "Hold Requests")
      ], -1)),
      _createElementVNode("div", _hoisted_4, _toDisplayString($setup.plural($setup.initialHoldCounter, "Hold Request")), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _createVNode($setup["DropDown"], { class: "dropdown dropdown--status" }, {
          control: _withCtx(() => [
            _createElementVNode("button", _hoisted_6, [
              _cache[2] || (_cache[2] = _createElementVNode("p", null, "Status is", -1)),
              ($setup.activeFilter.label === $setup.HoldStatusFilterLabel.PENDING_OR_ACTIVE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("div", { class: "item-filter" }, "Pending", -1),
                    _createElementVNode("p", null, "or", -1),
                    _createElementVNode("div", { class: "item-filter" }, "Active", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($setup.activeFilter.label), 1))
            ])
          ]),
          dropdown: _withCtx(() => [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filters, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  onClick: ($event: any) => ($setup.changeFilter(item)),
                  class: _normalizeClass({ 'dropdown__item-active': $setup.activeFilter.label === item.label })
                }, _toDisplayString(item.label), 11, _hoisted_9))
              }), 256))
            ])
          ]),
          _: 1
        })
      ])
    ]),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10))
      : (!$setup.initialHolds.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("img", {
              class: "empty-block--icon",
              src: require('@/assets/icons/star-slim.svg')
            }, null, 8, _hoisted_12),
            _createElementVNode("p", null, _toDisplayString($setup.emptyBlockText), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString($setup.plural($setup.initialHoldCounter, `${$setup.activeFilter.label} Hold Request`)), 1),
              _createElementVNode("table", _hoisted_16, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tableHeaders, (header, index) => {
                      return (_openBlock(), _createElementBlock("th", {
                        key: index,
                        class: _normalizeClass(`column--${$setup.toKebabCase(header)}}`)
                      }, _toDisplayString(header), 3))
                    }), 128))
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortedInitialHolds, (item, index) => {
                  return (_openBlock(), _createElementBlock("tbody", { key: index }, [
                    (item.initialHold.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.initialHold, (row, j) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: "cursor-pointer",
                            key: j,
                            onClick: ($event: any) => ($setup.onRow(row._id))
                          }, [
                            _createElementVNode("td", _hoisted_18, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["bordered", $setup.getInitialHoldStatusClass(row.status)])
                              }, null, 2),
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("span", _hoisted_20, "Lot " + _toDisplayString(item.lot.title), 1)
                              ])
                            ]),
                            _createElementVNode("td", null, _toDisplayString(item.lot.streetName || "--"), 1),
                            _createElementVNode("td", null, _toDisplayString(row.leadsDetails.firstName + " " + row.leadsDetails.lastName), 1),
                            _createElementVNode("td", null, _toDisplayString(row.leadsDetails.email), 1),
                            _createElementVNode("td", null, _toDisplayString(row.leadsDetails.phone), 1),
                            _createElementVNode("td", null, _toDisplayString(row?.companyDetails || "-"), 1),
                            _createElementVNode("td", null, _toDisplayString($setup.formatDate(row.createdAt)), 1),
                            _createElementVNode("td", null, _toDisplayString($setup.getExpirationDate(row.expirationDate)), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["badge", $setup.getInitialHoldStatusClass(row.status)])
                              }, _toDisplayString($setup.getInitialHoldStatusText(row.status)), 3)
                            ]),
                            ($setup.estateHasCollaborators)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString($setup.getInitialHoldBusiness(row)), 1))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_17))
                        }), 128))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ]))
  ]))
}